import { createAsyncThunk, createSlice /*, createSelector */ } from "@reduxjs/toolkit";
import { fetchOpportunityAccountData, fetchOpportunityUserData } from "../../features/opportunities/data/opportunitiesService";

const initialState = {
  accounts: [],
  users: [],
  status: "idle",
  error: null,
};

export const opportunitiesSlice = createSlice({
  name: "opportunities",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchOpportunityAccounts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.accounts = action.payload;
      })
      .addCase(fetchOpportunityAccounts.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchOpportunityAccounts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchOpportunityUsers.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.users = action.payload;
      })
      .addCase(fetchOpportunityUsers.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchOpportunityUsers.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const fetchOpportunityAccounts = createAsyncThunk(
  "permissions/fetchOpportunityAccounts",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchOpportunityAccountData();
      return response;
    } catch (error) {
      console.error("opportunityAccounts error:", error);
      return rejectWithValue(error.message || "Failed to fetch opportunity accounts");
    }
  }
);

export const fetchOpportunityUsers = createAsyncThunk(
  "permissions/fetchOpportunityUsers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchOpportunityUserData();
      return response;
    } catch (error) {
      console.error("opportunityUsers error:", error);
      return rejectWithValue(error.message || "Failed to fetch opportunity users");
    }
  }
);

export const getOpportunityAccounts = (state) => state.opportunities.accounts;
export const getOpportunityUsers = (state) => state.opportunities.users;

export const getOpportunityAccountById = (state, accountId) =>
  state.opportunities.accounts.find((acc) => acc.Id === accountId);

export const getOpportunityUserById = (state, userId) =>
  state.opportunities.users.find((user) => user.Id === userId);

export const getOpportunitiesStatus = (state) => state.opportunities.status;
export const getOpportunitiesError = (state) => state.opportunities.error;

export default opportunitiesSlice.reducer;
